module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_09.b2c4f5d9.svg";